export const ALL_EVENTS = 'events.ALL_EVENTS';
export const REMOVE_EVENT = 'events.REMOVE_EVENT';
export const ADD_EVENT = 'events.ADD_EVENT';
export const UPDATE_EVENT = 'event.UPDATE_EVENT';